import { render, staticRenderFns } from "./09-epg.vue?vue&type=template&id=356be485"
import script from "./09-epg.vue?vue&type=script&lang=ts"
export * from "./09-epg.vue?vue&type=script&lang=ts"
import style0 from "./09-epg.vue?vue&type=style&index=0&id=356be485&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports